module.exports = __webpack_public_path__ + "img/PPMP1.10e5b2d3.png";